import { Routes } from '@angular/router';
import { Reports } from './pages/reports/reports';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'signalements',
        pathMatch: 'full'
    },
    {
        path: 'signalements',
        component: Reports,
        title: 'Signalements',
    },
];
